import { Box } from "@mui/material"
import React, { useMemo } from "react"

import { SliderLayout } from "../../../generated/graphql"
import { s } from "../../../utilities/common"
import { Props, TeaserDimension, TeaserDimensions } from "../Slider"
import { Teaser } from "../Teaser"

export const NavigationSlider = ({ data, prefix, onPressTitle }: Props) => {
  const colSpacing = useMemo(
    () =>
      TeaserDimensions[TeaserDimension.LandscapeSmallTeaserNoText].colSpacing,
    [],
  )
  return (
    <Box
      component={"div"}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        mt: "-40px",
        ml: `-${colSpacing}`,
        pl: s("96px"),
        pr: s("96px"),
        width: `calc(100% + ${colSpacing})`,
        boxSizing: "border-box",
      }}
    >
      {
        /*only display 8 items*/ data.teasers.slice(0, 8).map((item, i) => {
          if (item)
            return (
              <Box
                sx={{ pl: colSpacing, pt: "40px" }}
                key={prefix + "navigation" + item.id + i}
              >
                <Teaser
                  onPress={onPressTitle}
                  dimensions={TeaserDimension.LandscapeSmallTeaserNoText}
                  data={item}
                  scrollDirection={"vertical"}
                  me={"curatedScreenSearch"}
                  index={i}
                  colMargin={false}
                  sliderLayout={SliderLayout.Regular}
                />
              </Box>
            )
        })
      }
    </Box>
  )
}
